import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { TrendingUpIcon, UsersIcon, CheckCircleIcon, ArrowRightIcon, ShieldCheckIcon, BookOpenIcon, TargetIcon, BriefcaseIcon, DollarSignIcon, StarIcon, SparklesIcon, HeadphonesIcon, DatabaseIcon, MonitorIcon, BotIcon, GraduationCapIcon } from 'lucide-react';
import { CareerJourney } from '../components/CareerJourney';
import { CareerCalculator } from '../components/CareerCalculator';
export function Career2() {
  const benefits = [{
    icon: ShieldCheckIcon,
    title: 'Sistem Verificat',
    description: 'Nu reinventezi roata. Avem o "rețetă" clară, testată, care garantează rezultate dacă o urmezi pas cu pas.',
    color: 'bg-blue-100 text-blue-600'
  }, {
    icon: DollarSignIcon,
    title: 'Câștiguri Reale',
    description: 'Comisioane atractive și transparente. Veniturile tale cresc direct proporțional cu implicarea ta.',
    color: 'bg-green-100 text-green-600'
  }, {
    icon: BookOpenIcon,
    title: 'Training Complet',
    description: 'Nu ai nevoie de experiență. Îți oferim acces la cursuri, mentorat și toate resursele necesare pentru a deveni expert.',
    color: 'bg-purple-100 text-purple-600'
  }, {
    icon: TargetIcon,
    title: 'Foarte Ușor de Început',
    description: 'Proces de onboarding simplificat. În câteva zile poți avea deja primele vizionări și primele tranzacții.',
    color: 'bg-orange-100 text-orange-600'
  }];
  const steps = [{
    number: '01',
    title: 'Înregistrează-te',
    description: 'Creează-ți contul în platformă. Este primul pas către independența ta financiară.'
  }, {
    number: '02',
    title: 'Învață "Rețeta"',
    description: 'Parcurge cursurile noastre interactive. Îți explicăm exact ce ai de făcut, pas cu pas.'
  }, {
    number: '03',
    title: 'Aplică și Câștigă',
    description: 'Folosește instrumentele noastre digitale pentru a găsi clienți și a încheia tranzacții.'
  }];
  const tools = [{
    icon: MonitorIcon,
    title: 'Platformă Pro',
    description: 'Acces complet la pro.cautlocuinta.ro'
  }, {
    icon: DatabaseIcon,
    title: 'CRM Profesional',
    description: 'Gestionare clienți și proprietăți'
  }, {
    icon: GraduationCapIcon,
    title: 'Cursuri Masterclass',
    description: 'Training continuu și certificări'
  }, {
    icon: UsersIcon,
    title: 'Leaduri Zilnice',
    description: 'Liste de prospectare și clienți calificați'
  }, {
    icon: BotIcon,
    title: 'AI Assistant',
    description: 'Asistent inteligent disponibil 24/7'
  }, {
    icon: HeadphonesIcon,
    title: 'Suport Dedicat',
    description: 'Echipă de suport și mentor personal'
  }];
  return <div className="w-full min-h-screen bg-[#F1F1F1]" data-id="element-7451">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-[#132C53] to-[#1e4278] text-white overflow-hidden" data-id="element-7452">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-7453"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32 relative z-10" data-id="element-7454">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-7455">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-7456">
              <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6 border border-white/20" data-id="element-7457">
                <StarIcon className="w-4 h-4 text-yellow-400 fill-current" data-id="element-7458" />
                <span className="text-sm font-medium text-white" data-id="element-7459">
                  Cea mai rapidă cale către succes în imobiliare
                </span>
              </div>
              <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-7460">
                Devino Agent și <br data-id="element-7461" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#357BEB] to-[#21A366]" data-id="element-7462">
                  Preia Controlul
                </span>{' '}
                Veniturilor Tale
              </h1>
              <p className="text-xl text-gray-300 mb-8 max-w-lg leading-relaxed" data-id="element-7463">
                Avem rețeta succesului și vrem să ți-o oferim. Este mai ușor
                decât crezi să începi o carieră profitabilă în imobiliare, chiar
                și fără experiență anterioară.
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-7464">
                <Link to="/auth/register" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-2xl text-white bg-gradient-to-r from-[#357BEB] to-[#21A366] hover:shadow-lg hover:scale-105 transition-all duration-300 group" data-id="element-7465">
                  Devino Agent
                  <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-7466" />
                </Link>
                <a href="#cum-functioneaza" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-2xl text-white border-2 border-white/20 hover:bg-white/10 transition-all" data-id="element-7467">
                  Cum funcționează?
                </a>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative hidden lg:block" data-id="element-7468">
              <div className="relative z-10 bg-white/5 backdrop-blur-md rounded-3xl p-8 border border-white/10 shadow-2xl" data-id="element-7469">
                <div className="flex items-center justify-between mb-8" data-id="element-7470">
                  <div data-id="element-7471">
                    <p className="text-gray-400 text-sm" data-id="element-7472">Venituri estimate</p>
                    <h3 className="text-3xl font-bold text-white" data-id="element-7473">
                      €4,500<span className="text-lg text-gray-400" data-id="element-7474">/lună</span>
                    </h3>
                  </div>
                  <div className="w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center" data-id="element-7475">
                    <TrendingUpIcon className="w-6 h-6 text-green-400" data-id="element-7476" />
                  </div>
                </div>
                <div className="space-y-4" data-id="element-7477">
                  <div className="flex items-center justify-between p-4 bg-white/5 rounded-xl border border-white/5" data-id="element-7478">
                    <div className="flex items-center space-x-3" data-id="element-7479">
                      <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center" data-id="element-7480">
                        <UsersIcon className="w-5 h-5 text-blue-400" data-id="element-7481" />
                      </div>
                      <div data-id="element-7482">
                        <p className="font-semibold text-white" data-id="element-7483">Leaduri Noi</p>
                        <p className="text-xs text-gray-400" data-id="element-7484">Săptămâna asta</p>
                      </div>
                    </div>
                    <span className="text-xl font-bold text-white" data-id="element-7485">+12</span>
                  </div>
                  <div className="flex items-center justify-between p-4 bg-white/5 rounded-xl border border-white/5" data-id="element-7486">
                    <div className="flex items-center space-x-3" data-id="element-7487">
                      <div className="w-10 h-10 bg-purple-500/20 rounded-lg flex items-center justify-center" data-id="element-7488">
                        <BriefcaseIcon className="w-5 h-5 text-purple-400" data-id="element-7489" />
                      </div>
                      <div data-id="element-7490">
                        <p className="font-semibold text-white" data-id="element-7491">Tranzacții</p>
                        <p className="text-xs text-gray-400" data-id="element-7492">În procesare</p>
                      </div>
                    </div>
                    <span className="text-xl font-bold text-white" data-id="element-7493">3</span>
                  </div>
                </div>
                <div className="mt-8 pt-6 border-t border-white/10" data-id="element-7494">
                  <div className="flex items-center space-x-2 text-sm text-gray-300" data-id="element-7495">
                    <CheckCircleIcon className="w-4 h-4 text-green-400" data-id="element-7496" />
                    <span data-id="element-7497">Sistem complet digitalizat</span>
                  </div>
                  <div className="flex items-center space-x-2 text-sm text-gray-300 mt-2" data-id="element-7498">
                    <CheckCircleIcon className="w-4 h-4 text-green-400" data-id="element-7499" />
                    <span data-id="element-7500">Suport dedicat 24/7</span>
                  </div>
                </div>
              </div>
              <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#357BEB] rounded-full blur-3xl opacity-30" data-id="element-7501"></div>
              <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-[#21A366] rounded-full blur-3xl opacity-30" data-id="element-7502"></div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-7503">
        <div className="text-center mb-16" data-id="element-7504">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-7505">
            <h2 className="text-3xl md:text-4xl font-bold text-[#132C53] mb-4" data-id="element-7506">
              De ce să alegi Cautlocuință.ro?
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-7507">
              Nu îți oferim doar un job, ci un ecosistem complet construit
              pentru succesul tău.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-7508">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100" data-id="element-7509">
              <div className={`w-14 h-14 rounded-2xl ${benefit.color} flex items-center justify-center mb-6`} data-id="element-7510">
                <benefit.icon className="w-7 h-7" data-id="element-7511" />
              </div>
              <h3 className="text-xl font-bold text-[#132C53] mb-3" data-id="element-7512">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-7513">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>

      {/* How it works Section */}
      <div id="cum-functioneaza" className="bg-white py-20" data-id="element-7514">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-7515">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-7516">
            <div data-id="element-7517">
              <motion.div initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6
            }} data-id="element-7518">
                <h2 className="text-3xl md:text-4xl font-bold text-[#132C53] mb-6" data-id="element-7519">
                  Avem Rețeta Succesului. <br data-id="element-7520" />
                  <span className="text-[#357BEB]" data-id="element-7521">
                    Trebuie doar să o aplici.
                  </span>
                </h2>
                <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-7522">
                  Am simplificat procesul de a deveni agent imobiliar. Nu te
                  aruncăm în piață fără direcție. Îți oferim o hartă clară,
                  instrumente digitale și suport constant.
                </p>

                <div className="space-y-8" data-id="element-7523">
                  {steps.map((step, index) => <motion.div key={index} initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.5,
                  delay: index * 0.1
                }} className="flex items-start space-x-4" data-id="element-7524">
                      <div className="flex-shrink-0 w-12 h-12 bg-[#132C53] text-white rounded-full flex items-center justify-center font-bold text-lg shadow-md" data-id="element-7525">
                        {step.number}
                      </div>
                      <div data-id="element-7526">
                        <h3 className="text-xl font-bold text-[#132C53] mb-2" data-id="element-7527">
                          {step.title}
                        </h3>
                        <p className="text-gray-600" data-id="element-7528">{step.description}</p>
                      </div>
                    </motion.div>)}
                </div>

                <div className="mt-10" data-id="element-7529">
                  <Link to="/auth/register" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-2xl text-white bg-[#132C53] hover:bg-[#2868d8] transition-all shadow-lg hover:shadow-xl" data-id="element-7530">
                    Începe Acum
                    <ArrowRightIcon className="ml-2 w-5 h-5" data-id="element-7531" />
                  </Link>
                </div>
              </motion.div>
            </div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="relative" data-id="element-7532">
              <div className="absolute inset-0 bg-gradient-to-br from-[#357BEB] to-[#21A366] rounded-3xl transform rotate-3 opacity-20" data-id="element-7533"></div>
              <img src="https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Team working together" className="relative rounded-3xl shadow-2xl w-full object-cover h-[600px]" data-id="element-7534" />
              <div className="absolute bottom-8 left-8 right-8 bg-white/90 backdrop-blur-md p-6 rounded-2xl shadow-lg border border-white/20" data-id="element-7535">
                <div className="flex items-center space-x-4" data-id="element-7536">
                  <div className="flex -space-x-3" data-id="element-7537">
                    {[1, 2, 3, 4].map(i => <div key={i} className="w-10 h-10 rounded-full border-2 border-white bg-gray-200 overflow-hidden" data-id="element-7538">
                        <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="Agent" className="w-full h-full object-cover" data-id="element-7539" />
                      </div>)}
                  </div>
                  <div data-id="element-7540">
                    <p className="font-bold text-[#132C53]" data-id="element-7541">
                      Alătură-te echipei
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-7542">
                      Peste 500+ agenți activi
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* What You Get Section */}
      <div className="py-20 bg-[#F9FAFB]" data-id="element-7543">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-7544">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-16" data-id="element-7545">
            <h2 className="text-3xl md:text-4xl font-bold text-[#132C53] mb-4" data-id="element-7546">
              Tot Ce Ai Nevoie pentru Succes
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-7547">
              Instrumentele și suportul de care ai nevoie pentru a reuși ca
              agent imobiliar.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-7548">
            {tools.map((tool, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-all border border-gray-100" data-id="element-7549">
                <div className="w-12 h-12 bg-gradient-to-br from-[#357BEB] to-[#21A366] rounded-xl flex items-center justify-center mb-4" data-id="element-7550">
                  <tool.icon className="w-6 h-6 text-white" data-id="element-7551" />
                </div>
                <h3 className="text-lg font-bold text-[#132C53] mb-2" data-id="element-7552">
                  {tool.title}
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-7553">{tool.description}</p>
              </motion.div>)}
          </div>
        </div>
      </div>

      {/* Career Journey Section */}

      {/* Calculator Section */}
      <div className="py-20 bg-[#F9FAFB]" data-id="element-7554">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-7555">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-7556">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-7557">
              <h2 className="text-3xl md:text-4xl font-bold text-[#132C53] mb-6" data-id="element-7558">
                Calculează-ți Potențialul de Câștig
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-7559">
                La Cautlocuință.ro, transparența este cheia. Folosește
                calculatorul nostru pentru a vedea exact la ce nivel te poți
                situa și ce venituri poți genera în funcție de activitatea ta.
              </p>
              <ul className="space-y-4 mb-8" data-id="element-7560">
                <li className="flex items-center space-x-3 text-gray-700" data-id="element-7561">
                  <CheckCircleIcon className="w-5 h-5 text-[#21A366]" data-id="element-7562" />
                  <span data-id="element-7563">Sistem de comisionare progresiv</span>
                </li>
                <li className="flex items-center space-x-3 text-gray-700" data-id="element-7564">
                  <CheckCircleIcon className="w-5 h-5 text-[#21A366]" data-id="element-7565" />
                  <span data-id="element-7566">Bonusuri de performanță</span>
                </li>
                <li className="flex items-center space-x-3 text-gray-700" data-id="element-7567">
                  <CheckCircleIcon className="w-5 h-5 text-[#21A366]" data-id="element-7568" />
                  <span data-id="element-7569">Acces la leaduri premium pe măsură ce avansezi</span>
                </li>
              </ul>
            </motion.div>
            <div data-id="element-7570">
              <CareerCalculator data-id="element-7571" />
            </div>
          </div>
        </div>
      </div>

      {/* Final CTA Section */}
      <div className="bg-[#132C53] py-20 relative overflow-hidden" data-id="element-7572">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-7573"></div>
        <div className="absolute top-0 right-0 w-64 h-64 bg-[#357BEB] rounded-full blur-3xl opacity-20 transform translate-x-1/2 -translate-y-1/2" data-id="element-7574"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#21A366] rounded-full blur-3xl opacity-20 transform -translate-x-1/2 translate-y-1/2" data-id="element-7575"></div>

        <div className="max-w-4xl mx-auto px-4 text-center relative z-10" data-id="element-7576">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-7577">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-7578">
              Ești gata să începi?
            </h2>
            <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-7579">
              Nu mai aștepta momentul perfect. Momentul este acum. Alătură-te
              comunității Cautlocuință.ro și construiește-ți viitorul.
            </p>
            <Link to="/auth/register" className="inline-flex items-center justify-center px-10 py-5 text-xl font-bold rounded-2xl text-white bg-gradient-to-r from-[#357BEB] to-[#21A366] hover:shadow-2xl hover:scale-105 transition-all duration-300 group" data-id="element-7580">
              Devino Agent
              <ArrowRightIcon className="ml-2 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-7581" />
            </Link>
            <p className="mt-6 text-sm text-gray-400" data-id="element-7582">
              Înregistrarea durează mai puțin de 2 minute.
            </p>
          </motion.div>
        </div>
      </div>
    </div>;
}